import { FaTrash } from 'react-icons/fa';

const TableOne = ({ ordLevel, setOrdLevel }) => {

    const removeLevel = (levelToDelete) => {
        
        let newOrdLevel = ordLevel.filter((level) => {
            return level.subject !== levelToDelete.subject ;
        });
        setOrdLevel(newOrdLevel);
    }
    return ( 
        <>
            <table className="mt-6">
                <thead>
                    <tr>
                        <th>Month</th>
                        <th>Year</th>
                        <th>O' Level Subject</th>
                        <th>Examination Board</th>
                        <th>Results / Grade</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>  
                        {
                            ordLevel && ordLevel.map(level => (
                                <tr key={level.subject}>
                                    <td>{ level.month }</td>
                                    <td>{ level.year }</td>    
                                    <td>{ level.subject }</td>    
                                    <td>{ level.board }</td>    
                                    <td>{ level.grade }</td> 
                                    <td><FaTrash color="#af0e19" onClick={() => removeLevel(level)} /></td> 
                                </tr>

                            ))
                        }           
                </tbody>
            </table>
        </>
     );
}
 
export default TableOne;